import validate from "/home/runner/work/RememoWeb/RememoWeb/node_modules/.pnpm/nuxt@3.18.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.3.0_@vue+compiler-sfc@3_ji5fyvu54zm5wuh56k76qtmhci/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/runner/work/RememoWeb/RememoWeb/middleware/auth.global.ts";
import manifest_45route_45rule from "/home/runner/work/RememoWeb/RememoWeb/node_modules/.pnpm/nuxt@3.18.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.3.0_@vue+compiler-sfc@3_ji5fyvu54zm5wuh56k76qtmhci/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}